module.exports = __webpack_public_path__ + "static/media/2.db47c140.jpg";